import update from 'immutability-helper';
import { ADD_NOTIFICATION } from '../actions/notificationsAction';

const notificationsReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return update(state, {
        [action.payload.id]: { $set: action.payload.id },
      });
    default:
      return state;
  }
};
export default notificationsReducer;
